<!-- =========================================================================================
  File Name: AttendeeEdit.vue
  Description: Attendee Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.attendee-form-wrap .con-slot-tabs {
    padding: 0 200px;
}
@media screen and (min-width:1367px) and (max-width: 1440px){
.attendee-form-wrap .con-slot-tabs {
    padding: 0 0px;
}
}
@media screen and (max-width:1366px) {
.attendee-form-wrap .con-slot-tabs {
    padding: 0 0px;
}
}
</style>
<template>
  <div id="page-user-edit" class="attendee-form-wrap">
    <div class="header-custome">
      <h3>Edit Round Table</h3>
    </div>
    <vs-alert
      color="danger"
      title="Round Table Not Found"
      :active.sync="user_not_found"
    >
      <span
        >RoundTable record with id: {{ $route.params.roundtableId }} not
        found.</span
      >
      <span>
        <span>Check</span>
        <router-link
          :to="{ name: 'page-user-list' }"
          class="text-inherit underline"
          >All Users</router-link
        >
      </span>
    </vs-alert>

    <vx-card v-if="user_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <div class="tab-text">
            <roundtable-edit-tab-account class="mt-4" :data="user_data" />
          </div>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import RoundtableEditTabAccount from "./RoundtableEditTabAccount.vue";

// Store Module
import moduleRoundtableManagement from "@/store/roundtable-management/moduleRoundtableManagement.js";

export default {
  components: {
    RoundtableEditTabAccount,
  },
  data() {
    return {
      user_data: null,
      user_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0,
    };
  },
  watch: {
    activeTab() {
      this.fetch_user_data(this.$route.params.roundtableId);
    },
  },
  methods: {

    fetch_user_data(roundtableId) {
      //console.log(roundtableId)
      this.$store
        .dispatch("roundtableManagement/fetchRoundTable", roundtableId)
        .then((res) => {
          if (res.data && res.data.TableType != "Open") {
            res.data.Spectate = false;
          }
          this.user_data = res.data;
        })
        .catch((err) => {
          /*if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }*/
          console.error(err);
        });
    },
  },
  created() {
    //debugger;
    // Register Module UserManagement Module
    if (!moduleRoundtableManagement.isRegistered) {
      this.$store.registerModule(
        "roundtableManagement",
        moduleRoundtableManagement
      );
      moduleRoundtableManagement.isRegistered = true;
    }
    this.fetch_user_data(this.$route.params.roundtableId);
  },
};
</script>